<template>
    <div class="col-lg-3 pr-lg-0">
        <nav class="d-lg-flex flex-lg-column my-4 my-lg-0 mt-lg-2">
            <div v-for="link in navigationLinks" :key="`${link.title}`">
                <NuxtLink v-if="link.tag === 'nuxt-link'"
                          :to="Route(`${link.route}`)"
                          class="d-inline-block mb-3 mb-lg-2 mr-3 text-nowrap"
                          v-text="`${link.title}`"
                />
                <BaseButton v-else
                            tag="a"
                            :href="Route(`${link.route}`)"
                            variant="link"
                            class="d-inline-block mb-3 mb-lg-2 mr-3 p-0 border-0 text-nowrap"
                            v-text="`${link.title}`"
                />
            </div>
        </nav>
    </div>
</template>
<script>
import Route from '@/extensions/Route/Route';
import BaseButton from '@/components/BaseButton';

export default {
    components: { BaseButton },
    data() {
        return {
            Route,
            BaseButton,
            navigationLinks: [
                { tag: 'nuxt-link', route: 'edit_profile', title: this.$t('student-profile-navlinks.edit-profile') },
                { tag: 'a', route: 'manage_account', title: this.$t('student-profile-navlinks.account') },
                { tag: 'nuxt-link', route: 'contact_preferences', title: this.$t('student-profile-navlinks.contact-preferences') },
                { tag: 'nuxt-link', route: 'billing', title: this.$t('student-profile-navlinks.billing') },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/_base';

  a {
    color: $text-muted;
    &:hover {
      color: $text-muted;
    }
  }

  a.nuxt-link-exact-active {
    font-weight: bold;
    color: $navy-blue;
  }

</style>
